"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.successResponseSchema = void 0;
const zod_1 = require("zod");
/** Body of the write endpoints that only acknowledge the action. */
exports.successResponseSchema = zod_1.z.object({ success: zod_1.z.boolean() });
